import { BodyText, BASE_RADIUS, BASE_PADDING } from "$components/DesignSystem"
import { View } from "react-native"
import { useTheme } from "styled-rn"

import { Popover } from "./Popovers"

export const PopoverTooltipBody = (props: { text: string }) => {
  const theme = useTheme()

  return (
    <View
      pointerEvents="none"
      style={{
        backgroundColor: theme.fg,
        borderRadius: BASE_RADIUS,
        paddingHorizontal: BASE_PADDING,
        paddingVertical: BASE_PADDING / 3,
        shadowColor: theme.alwaysDark,
        shadowOffset: {
          width: 0,
          height: 3,
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
      }}
    >
      <BodyText customColorKey="g_textLight" size="small">
        {props.text}
      </BodyText>
    </View>
  )
}

export const PopoverTooltip = (props: { disabled?: boolean; children: any; text: string }) => {
  return (
    <Popover disabled={props.disabled} placementPreference="bottom" render={() => <PopoverTooltipBody text={props.text} />}>
      <View>{props.children}</View>
    </Popover>
  )
}
